/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiPathStatusFromJSON, ApiPathStatusToJSON, } from './ApiPathStatus';
export function ApiReadLanderResponseFromJSON(json) {
    return ApiReadLanderResponseFromJSONTyped(json, false);
}
export function ApiReadLanderResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'canonical': !exists(json, 'canonical') ? undefined : json['canonical'],
        'componentId': !exists(json, 'componentId') ? undefined : json['componentId'],
        'deferIncendiumjs': !exists(json, 'deferIncendiumjs') ? undefined : json['deferIncendiumjs'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'noIndex': !exists(json, 'noIndex') ? undefined : json['noIndex'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'pending': !exists(json, 'pending') ? undefined : json['pending'],
        'screenshotUrl': !exists(json, 'screenshotUrl') ? undefined : json['screenshotUrl'],
        'status': !exists(json, 'status') ? undefined : ApiPathStatusFromJSON(json['status']),
        'subdomainId': !exists(json, 'subdomainId') ? undefined : json['subdomainId'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}
export function ApiReadLanderResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'canonical': value.canonical,
        'componentId': value.componentId,
        'deferIncendiumjs': value.deferIncendiumjs,
        'description': value.description,
        'id': value.id,
        'noIndex': value.noIndex,
        'path': value.path,
        'pending': value.pending,
        'screenshotUrl': value.screenshotUrl,
        'status': ApiPathStatusToJSON(value.status),
        'subdomainId': value.subdomainId,
        'url': value.url,
    };
}
